module.exports = __webpack_public_path__ + "media/images/countryrect/do-0984e4fc6fe7a32371f8391e150083e4.svg";